import styled, {css, createGlobalStyle} from "styled-components"

import {IconButton as IconButtonBase} from "@irati/ui/src/Button"

interface Props {
  // https://stackoverflow.com/questions/49028877/slick-carousel-force-slides-to-have-the-same-height
  maintainSameHeight?: boolean
}

export default createGlobalStyle<Props>`
.slick-slider {
  --dot-size: 10px;
  /* adding padding left to first element to align lanes with 1 result with ones with multiple results, also show cards shadow */
  .slick-slide:first-child .sc-dovdUy {
    padding: 0 4px 0 4px;
  }

  ${({theme, maintainSameHeight}) => css`
    .slick-track {
      margin-left: 0;
      margin-right: 0;
      ${maintainSameHeight && "display: flex;"}
    }
    
    .slick-slide {
      ${maintainSameHeight && "height: inherit;"}
      & > div {
        ${maintainSameHeight && "height: 100%;"}
      }
    }

    & > span {
      display: block;
    }

    .slick-dots li {
      height: var(--dot-size);
      width: var(--dot-size);
      margin: 0 ${theme.spacing.half};
    }

    .slick-dots li button {
      padding: 0;

      &,
      &::before {
        width: 100%;
        height: 100%;
      }
      &::before {
        font-size: var(--dot-size);
        line-height: var(--dot-size);
        color: ${theme.colors.utility.contrast};
      }
    }

    .slick-dots li.slick-active button:before {
      color: ${theme.colors.utility.white};
    }
  `}

  .slick-list {
    border-radius: ${({theme}) => theme.border.radius.large};
  }

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
      .slick-dots {
        display: flex;
        position: absolute;
        bottom: ${theme.spacing.two};
        right: ${theme.spacing.two};
        margin: 0;
        list-style: none;
        text-align: center;
        display: flex !important;
        justify-content: flex-end !important;
      }
      /* adding padding left to first element to align lanes with 1 result with ones with multiple results, also show cards shadow */
      .slick-slide:first-child .sc-dovdUy {
        padding: 0 8px 0 8px;
      }
    `}

}
`
interface IconButtonProps {
  previousNav?: boolean
}
export const IconButton = styled(IconButtonBase).attrs({size: 24})<IconButtonProps>`
  position: absolute;
  z-index: 10;
  background: white;
  top: 50%;
  border-radius: 2px;
  padding: ${({theme}) => theme.spacing.one};
  transform: ${({previousNav}) => (previousNav ? "translate3D(-50%,-50%,0)" : "translate3D(50%,-50%,0)")};
  left: ${({previousNav}) => (previousNav ? "0" : "auto")};
  right: ${({previousNav}) => (previousNav ? "auto" : "0")};
  box-shadow: ${({theme}) => theme.shadows.low};
`

export const SliderContainer = styled.div`
  ${({theme}) => css`
    position: relative;
    padding: ${theme.spacing.two} ${theme.spacing.five} ${theme.spacing.four};
    border-radius: ${theme.border.radius.large};
    background-color: ${theme.colors.utility.highlight};
    box-shadow: ${theme.shadows.low};
    .slick-slider {
      .slick-dots {
        text-align: right;
      }
    }
  `}
`

export const ArrowsWrapper = styled.div`
  ${({theme}) => css`
    position: absolute;
    height: 100%;
    width: 100%;
    > span {
      position: absolute;
      top: 30%;
      z-index: 1;
      &:first-child {
        left: -${theme.spacing.four};
      }
      &:last-child {
        right: ${theme.spacing.six};
      }
    }
  `}
`
